var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Page',{attrs:{"mode":"jacket"}},[_c('h1',[_vm._v(_vm._s(_vm.labels.YourPersonalCitizenAccount))]),_c('p',{domProps:{"innerHTML":_vm._s(_vm.labels.Introduction)}}),_c('br'),_c('p',[_vm._v(" "+_vm._s(_vm.labels.SystemAccessError)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }